import fr from 'facet-rest';
import SummaryCardDataCell
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/SummaryCardPicker/SummaryCard/SummaryCardDataCell';


const metaOverrides = fr.metaOverride().override(
  { readonly: true },
  {
    _component: () => SummaryCardDataCell,
  },
  {
    ordinal: 500,
  },
);

export default metaOverrides;
